import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCommentFilled = () => {
  return (
    <g>
      <path d="M9.759.004 6.244 0A6.247 6.247 0 0 0 0 6.25l.004.229a6.253 6.253 0 0 0 6.247 6.027h.999v2.742a.75.75 0 0 0 1.075.677l2.302-1.11A9.498 9.498 0 0 0 16 6.259 6.251 6.251 0 0 0 9.759.004z" />
    </g>
  );
};

export default withIcon(IconCommentFilled);
